export default "__VITE_ASSET__DRms5cJs__"